import React, { useState } from "react"
import { TextField, InputAdornment, IconButton } from "@mui/material"
import { Visibility, VisibilityOff, AutoAwesome } from "@mui/icons-material"

interface PasswordFieldProps {
  password: string
  setPassword: (password: string) => void
  generatePassword: () => string
}

function PasswordField({
  password,
  setPassword,
  generatePassword,
}: Readonly<PasswordFieldProps>) {
  const [showPassword, setShowPassword] = useState(false)

  const isValidPassword = (password: string) => {
    const passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/
    return passwordRegex.test(password)
  }

  const errorState = !!(password && !isValidPassword(password))
  const helperText = errorState
    ? "Password must be at least 6 characters, include a number, and a special character (!, @, #, $, %, ^, &, or *)."
    : ""

  return (
    <TextField
      label="Password"
      type={showPassword ? "text" : "password"}
      variant="outlined"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      fullWidth
      margin="normal"
      error={errorState}
      helperText={helperText}
      required
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IconButton
              onClick={() => setPassword(generatePassword())}
              edge="start"
            >
              <AutoAwesome />
            </IconButton>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default PasswordField
